export const currentThemeSchemaVersion = "2.0";
export const currentThemeVersion = "1.0.0";
//# sourceMappingURL=contracts.js.map